var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulletList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.527 4.944H9.805c-.473 0-.789-.315-.789-.788 0-.473.316-.789.789-.789h10.722c.473 0 .788.316.788.789 0 .473-.315.788-.788.788zm0 7.884H9.805c-.473 0-.789-.316-.789-.789 0-.473.316-.788.789-.788h10.722c.473 0 .788.315.788.788 0 .473-.315.789-.788.789zm0 7.884H9.805c-.473 0-.789-.316-.789-.789 0-.473.316-.788.789-.788h10.722c.473 0 .788.315.788.788 0 .473-.315.789-.788.789zm-16.871.812c-.527-.02-.789-.34-.789-.34l-.63-.63a.762.762 0 010-1.104.762.762 0 011.103 0l.316.316 1.103-1.262a.762.762 0 011.104 0 .762.762 0 010 1.104L4.5 21.185s-.318.358-.844.339zm0-7.768c-.527-.019-.789-.339-.789-.339l-.63-.63a.762.762 0 010-1.104.762.762 0 011.103 0l.316.315 1.103-1.261a.762.762 0 011.104 0 .762.762 0 010 1.103L4.5 13.417s-.318.359-.844.34zm0-8c-.527-.019-.789-.339-.789-.339l-.63-.63a.762.762 0 010-1.104.762.762 0 011.103 0l.316.315 1.103-1.261a.762.762 0 011.104 0 .762.762 0 010 1.103L4.5 5.417s-.318.359-.844.34z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletList);
export default __webpack_public_path__ + "static/media/bullet-list.1281bc37551862770dc27e405a696f6e.svg";
export { ForwardRef as ReactComponent };